﻿import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import moment from "moment";

export function DateToLocal(
    {
        format = "DD/MM/YYYY HH:mm",
        invalidDateString = "-",
        hideTimeIfMidnight = false,
        inputFormat = "",
        children
    }
) {

	const [dateOutput, setDateOutput] = useState("");

	useEffect(() => {

		var dateUtcMoment = null;
		if (inputFormat !== "") {
			dateUtcMoment = moment.utc(children, inputFormat);
		}
		else {
			dateUtcMoment = moment.utc(children);
		}

		var formatValue = format;

		if (dateUtcMoment.isValid()) {
			var dateUtc = dateUtcMoment.toDate();

			if (hideTimeIfMidnight && formatValue !== "DD/MM/YYYY") {
				if (dateUtc.getSeconds() === 0 && dateUtc.getMinutes() === 0 && dateUtc.getHours() === 0) {
					formatValue = "DD/MM/YYYY";
				}
			}

			setDateOutput(moment(dateUtc).local().format(formatValue));
		} else {
			setDateOutput(invalidDateString);
		}
	}, [children]);


	return (
		<Fragment>{dateOutput}</Fragment>
	);
}

DateToLocal.propTypes = {
	format: PropTypes.string,
	invalidDateString: PropTypes.string,
	hideTimeIfMidnight: PropTypes.bool,
	inputFormat: PropTypes.string,
	children: PropTypes.node
};